/**
 * Does a granted set satisfy `required`? Supports `*` (everything) and group wildcards such as
 * `control.*` or `admin.servers.*`. On its own (permissions.js re-exports it) so the web app's entry
 * chunk can check permissions without the permission lists.
 */
export function hasPermission(granted, required) {
  for (const g of granted) {
    if (g === '*' || g === required) return true;
    if (g.endsWith('.*') && required.startsWith(g.slice(0, -1))) return true;
  }
  return false;
}
